import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class UnitOfMeasureReferenceService extends BaseReferenceService {
  constructor() {
    super('UnitOfMeasureReference');
  }
}
